<template>
    <div v-if="shows">
        <v-card flat outlined rounded="xl">
            <v-btn v-bind="{ loading }" small icon color="white" class="primary" @click="$emit('down')">
                <v-icon>mdi-file-download</v-icon>
            </v-btn>
        </v-card>
    </div>
</template>

<script>
export default {
    props: {
        /** @type {import('vue').PropType<'form'|'sign'|'view'|'done''>} */
        mode: { type: String, default: "form" },
        loading: { type: Boolean, default: false },
    },
    computed: {
        shows() {
            switch (this.mode) {
                case "done": {
                    return true;
                }

                default: {
                    return false;
                }
            }
        },
    },
};
</script>

<style></style>
